<div [formGroup]="formulario" *ngIf="!controlGroup" [ngClass]="{'error': classError}">

    <p-calendar appendTo="body" *ngIf="timeOnly" [formControlName]="controlName" [timeOnly]="true" [readonlyInput]="!editable"
        [stepMinute]="stepMinute" (keydown.backspace)="backSpacePressed($event)" [disabled]="disabled"
        [(ngModel)]="timeVal" (onTodayClick)="getTime($event)" [showButtonBar]="showButtonBar" [locale]="idioma">
    </p-calendar>

    <p-calendar *ngIf="!timeOnly" [minDate]="minDateValue" [maxDate]="maxDateValue" [showButtonBar]="showButtonBar"
        [showTime]="showTime" [monthNavigator]="true" [readonlyInput]="!editable" [yearNavigator]="true"
        [yearRange]="yearRange" [locale]="idioma" [formControlName]="controlName" dateFormat="{{getFormat()}}"
        appendTo="body" showIcon="true" (keydown.backspace)="backSpacePressed($event)"
        [clearButtonStyleClass]="clearButtonStyleClass" [todayButtonStyleClass]="todayButtonStyleClass"
        styleClass="{{styleClass}}" [disabled]="disabled">
    </p-calendar>
</div>


<div [formGroup]="formulario" *ngIf="controlGroup">
    <div [formGroupName]="controlGroup" [ngClass]="{'error': classError}">

        <p-calendar appendTo="body" *ngIf="timeOnly" [formControlName]="controlName" [timeOnly]="true"
            [stepMinute]="stepMinute" [readonlyInput]="!editable" (keydown.backspace)="backSpacePressed($event)" [disabled]="disabled"
            [(ngModel)]="timeVal" (onTodayClick)="getTime($event)" [showButtonBar]="showButtonBar" [locale]="idioma">
        </p-calendar>

        <p-calendar *ngIf="!timeOnly" [minDate]="minDateValue" [maxDate]="maxDateValue" [readonlyInput]="!editable"
            [showTime]="showTime" [monthNavigator]="true" [yearNavigator]="true" [yearRange]="yearRange"
            [locale]="idioma" [formControlName]="controlName" dateFormat="{{getFormat()}}" appendTo="body"
            showIcon="true" [showButtonBar]="showButtonBar" (keydown.backspace)="backSpacePressed($event)"
            [clearButtonStyleClass]="clearButtonStyleClass" [todayButtonStyleClass]="todayButtonStyleClass"
            styleClass="{{styleClass}}" [disabled]="disabled">
        </p-calendar>
    </div>

</div>
